import React from 'react';

import { Box, Typography } from '@mui/material';



import Hero from '../../Elements/Hero';
import HeroText from '../../Elements/HeroText';
import useTitle from '../../Utilities/useTitle';
import PageContainer from './../../Elements/PageContainer';

import CampaignsHeroImage from '../../../assets/media/hero/campaigns.jpg';

export default function ResourcesIndex () {
    useTitle('Resources');

    return (
        <>
            <Hero image={CampaignsHeroImage}>
                <HeroText>
                    <Typography variant="h4" sx={{mb: 1}}>Getting Started Guide</Typography>
                    <Typography paragraph>This guide gives a brief overview of {process.env.REACT_APP_WEBSITE_NAME}'s Campaigns platform showing it's various features & benefits along with instructions on how you can create your own campaigns.</Typography>
                </HeroText>
            </Hero>
            <PageContainer>
                <Typography variant="h4">Onboarding Video</Typography>

                <Box sx={{mt: 2}}>
                    <video controls width="100%" height="auto" src="https://cdn.campaigns.wmgconnect.com/media/WarnerConnectOnboarding.mp4" />
                </Box>

            </PageContainer>
        </>
    );

};
